import type {ReactNode} from 'react'
import {ArchiveDialogProvider} from '../../contexts/ArchiveDialogContext'
import {DeleteTaskDialogProvider} from '../../contexts/DeleteTaskDialogContext'
import {TaskSharingDialogProvider} from '../../contexts/TaskSharingDialogContext'
import {ArchiveConfirmationDialog} from '../ArchiveConfirmationDialog'
import {DeleteTaskDialogRendered} from '../DeleteTaskDialogRendered'
import {TaskSharingDialogRendered} from '../TaskSharingDialogRendered'

/**
 * Bundles archive, delete, and sharing providers and dialogs that any task action
 * surface needs — list views, chat views, sidebars, etc. Wrap a subtree
 * with this component to enable archive/delete/sharing actions. Each consumer
 * should place <ArchiveErrorBanner /> where it visually fits.
 */
export function TaskActionProviders({
  children,
  navigateOnDelete,
  navigateOnDeleteTaskId,
  deletionDestination,
  onDeleteSuccess,
  chatApiUrl,
  onTaskStateChange,
}: {
  children: ReactNode
  navigateOnDelete?: boolean
  navigateOnDeleteTaskId?: string
  deletionDestination?: string
  onDeleteSuccess?: (taskId: string) => void
  chatApiUrl?: string
  onTaskStateChange?: (taskId: string) => void
}) {
  return (
    <ArchiveDialogProvider chatApiUrl={chatApiUrl} onTaskStateChange={onTaskStateChange}>
      <TaskSharingDialogProvider>
        <DeleteTaskDialogProvider chatApiUrl={chatApiUrl}>
          {children}
          <ArchiveConfirmationDialog />
          <TaskSharingDialogRendered />
          <DeleteTaskDialogRendered
            navigateOnDelete={navigateOnDelete}
            navigateOnDeleteTaskId={navigateOnDeleteTaskId}
            deletionDestination={deletionDestination}
            onDeleteSuccess={onDeleteSuccess}
          />
        </DeleteTaskDialogProvider>
      </TaskSharingDialogProvider>
    </ArchiveDialogProvider>
  )
}
